import img1 from "./img/1.jpg";
import img4 from "./img/4.jpg";
import img5 from "./img/5.jpg";
import img6 from "./img/6.jpg";
import img11 from "./img/11.jpg";
import img12 from "./img/12.jpg";
import img14 from "./img/14.jpg";
import img15 from "./img/15.png";
import img16 from "./img/16.png";
import img17 from "./img/17.png";
import img18 from "./img/18.jpeg";
import img19 from "./img/19.jpg";
import img20 from "./img/20.jpg";
import img21 from "./img/21.png";
import img22 from "./img/22.png";
import img23 from "./img/23.jpg";
import img24 from "./img/24.jpg";
import img25 from "./img/25.png";
import img26 from "./img/26.png";
import img27 from "./img/27.png";
import img28 from "./img/28.jpg";
import img29 from "./img/29.jpg";
import img30 from "./img/30.jpg";
import img31 from "./img/31.jpg";
import img32 from "./img/32.jpg";
import img33 from "./img/33.png";
import img34 from "./img/34.jpg";
import img35 from "./img/35.png";
import img36 from "./img/36.jpg";
import img37 from "./img/37.jpeg";
import img38 from "./img/38.png";
import img40 from "./img/40.png";
import img41 from "./img/41.png";
import img42 from "./img/42.jpg";
import img43 from "./img/43.jpg";
import img44 from "./img/44.jpg";
import img45 from "./img/45.jpg";
import img46 from "./img/46.jpg";
import img47 from "./img/47.png";
import img48 from "./img/48.png";
import img49 from "./img/49.jpg";
import img50 from "./img/50.jpg";
import img51 from "./img/51.jpg";

export default {
  img1: img1,
  img4: img4,
  img5: img5,
  img6: img6,
  img11: img11,
  img12: img12,
  img14: img14,
  img15: img15,
  img16: img16,
  img17: img17,
  img18: img18,
  img19: img19,
  img20: img20,
  img21: img21,
  img22: img22,
  img23: img23,
  img24: img24,
  img25: img25,
  img26: img26,
  img27: img27,
  img28: img28,
  img29: img29,
  img30: img30,
  img31: img31,
  img32: img32,
  img33: img33,
  img34: img34,
  img35: img35,
  img36: img36,
  img37: img37,
  img38: img38,
  img40: img40,
  img41: img41,
  img42: img42,
  img43: img43,
  img44: img44,
  img45: img45,
  img46: img46,
  img47: img47,
  img48: img48,
  img49: img49,
  img50: img50,
  img51: img51,
};
